import { useState } from "react"
import { Button, Col, Container, Row, Stack } from "react-bootstrap"
import { useParams } from "react-router"
import { navigateTo } from "../../../redux/router/routerActions"
import { useAppDispatch } from "../../../redux/store"
import { useDeleteAdditionalServiceMutation, useGetAdditionalServiceByIdQuery } from "../../../services/bClientApi"
import AdditionalServiceEntry from "../../../Components/AdditionalService/AdditionalServiceEntry/AdditionalServiceEntry"

export default function DeleteAdditionalServicePage() {

    const [
        deleteAdditionalService,
        {
            isLoading: deleteLoading,
            error: deleteError
        }
    ] = useDeleteAdditionalServiceMutation()

    const { additionalServiceId = '' } = useParams()
    const dispatch = useAppDispatch()

    const [deleteClicked, setDeleteClicked] = useState(false)

    const {
        data,
        error,
        isLoading
    } = useGetAdditionalServiceByIdQuery(additionalServiceId, { skip: !additionalServiceId || deleteClicked })
    const additionalServiceData = data || {}

    const additionalServiceDeleteFn = async () => {
        if (additionalServiceId) {
            const deleteValue = await deleteAdditionalService(additionalServiceId).unwrap()
            if (deleteValue) {
                dispatch(navigateTo('/additional-services/'))
            }
        }
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Delete Additional Service</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}
                    {deleteError && (<>{JSON.stringify(deleteError)}<br /></>)}

                    {additionalServiceId && additionalServiceData && !isLoading && (
                        <div className="additional-service-info">
                            <div className="mb-4">
                                <h4>Service to Delete</h4>
                                <AdditionalServiceEntry
                                    additionalServiceData={additionalServiceData}
                                    fullView={true}
                                    showActions={false}
                                />
                            </div>

                            <Stack gap={3}>
                                <div className="alert alert-warning">
                                    <strong>Warning!</strong> Are you sure you want to delete this additional service? This action cannot be undone.
                                </div>
                                <div>
                                    <Button 
                                        variant="secondary" 
                                        className="me-2"
                                        onClick={() => dispatch(navigateTo(`/additional-services/${additionalServiceId}`))}
                                    >
                                        Cancel
                                    </Button>
                                    <Button 
                                        variant="warning" 
                                        onClick={() => setDeleteClicked(true)}
                                        disabled={deleteClicked}
                                    >
                                        Delete Additional Service
                                    </Button>
                                </div>
                                {deleteClicked && (
                                    <div className="alert alert-danger">
                                        <strong>Final Confirmation:</strong> This additional service will be permanently deleted. This action cannot be undone.
                                        <br /><br />
                                        <Button 
                                            variant="danger" 
                                            disabled={deleteLoading} 
                                            onClick={() => {
                                                additionalServiceDeleteFn()
                                            }}
                                        > 
                                            {deleteLoading ? 'Deleting...' : 'Confirm Delete Additional Service'}
                                        </Button>
                                    </div>
                                )}
                            </Stack>

                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    )
}
